import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there’s a hash, scroll to that element
    if (hash) {
      const id = hash.slice(1);

      // wait for the new page to paint
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        // if not mounted yet, observe until it appears
        const obs = new MutationObserver(() => {
          const target = document.getElementById(id);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            obs.disconnect();
          }
        });
        obs.observe(document.body, { childList: true, subtree: true });
        // safety: stop observing after a bit
        setTimeout(() => obs.disconnect(), 3000);
      });
      return;
    }

    // No hash → always go to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
